import Layout from "../../../components/layout/layout.js";

import ReportForm from "../../../components/form/report.form";

function ReportPage({ component, ...rest }) {
  return <Layout Component={ReportForm} {...rest} controlsDisabled={true} />;
}

export default ReportPage;
